import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from 'theme-ui'

import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'
import { PriceBoxStyleProps } from './types'

const PriceBoxTopStyled = styled.div<WithTheme<PriceBoxStyleProps>>`
  @media ${media.desktop} {
    padding-left: 2.5rem;
  }

  ${({ isSmall, theme }) =>
    isSmall &&
    css`
      @media ${media.desktop} {
        padding-left: 0;
      }
    `}
`

const PriceBoxTitleStyled = styled(Text)`
  margin-bottom: 1.875rem;
  @media ${media.phone} {
    margin-bottom: 2.5rem;
  }
`

const PriceBoxCostStyled = styled(Text)``

const PriceBoxDescStyled = styled(Text)<WithTheme>`
  position: relative;
  padding-bottom: 1rem;
  margin-bottom: 3.5rem;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 5.125rem;
    height: 0.0625rem;
    background-color: ${({ theme }) => theme.colors.black};
    opacity: 0.3;

    ${({ theme }) =>
      theme.direction === 'rtl'
        ? css`
            right: 0;
          `
        : css`
            left: 0;
          `}
  }
`

const PriceBoxDataStyled = styled.div`
  margin-bottom: 3.375rem;
  @media ${media.phone} {
    margin-bottom: 5.125rem;
  }
`

const PriceBoxCtaStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  width: 12.375rem;
  margin: auto auto 0;
`

const PriceBoxCtaCaptionStyled = styled(Text)`
  margin-top: 0.5rem;
  font-size: 0.625rem;
  text-align: center;
`

const PriceBoxStyled = styled.div<WithTheme>`
  display: flex;
  flex-direction: column;
  border-radius: 1.5625rem;
  width: 100%;
  box-shadow: 0rem 0.1875rem 0.625rem rgba(0, 0, 0, 0.3);
  padding: 3.5rem 1.75rem 3.125rem 1.75rem;
  background-color: ${({ theme }) => theme.colors.white};

  @media ${media.phone} {
    padding: 5.375rem 1.5rem 3.125rem 1.75rem;
  }
`

export {
  PriceBoxStyled,
  PriceBoxTopStyled,
  PriceBoxTitleStyled,
  PriceBoxCostStyled,
  PriceBoxDescStyled,
  PriceBoxDataStyled,
  PriceBoxCtaStyled,
  PriceBoxCtaCaptionStyled
}
